import React from 'react'
import { useNotifications } from '@/hooks/useNotifications'
import { formatDistanceToNow } from 'date-fns'

interface Props { onClose: () => void }

export function NotificationDropdown({ onClose }: Props) {
  const { notifications, loading, markAsRead, markAllAsRead } = useNotifications()

  return (
    <div className="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
      <div className="flex items-center justify-between p-4 border-b border-gray-200">
        <h3 className="font-semibold">Notifications</h3>
        <div className="flex items-center gap-2">
          {notifications.some(n => !n.read_at) && (
            <button onClick={markAllAsRead} className="text-xs text-blue-600 hover:text-blue-800">Mark all read</button>
          )}
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded" aria-label="Close">✕</button>
        </div>
      </div>
      <div className="max-h-96 overflow-y-auto">
        {loading ? (
          <div className="flex items-center justify-center py-8">
            <div className="h-5 w-5 animate-spin rounded-full border-2 border-gray-300 border-t-transparent" />
          </div>
        ) : notifications.length === 0 ? (
          <p className="text-center py-8 text-gray-500 text-sm">No notifications yet</p>
        ) : (
          notifications.map(n => (
            <div key={n.id} className={`p-4 border-b border-gray-100 hover:bg-gray-50 cursor-pointer transition-colors ${!n.read_at ? 'bg-blue-50' : ''}`} onClick={() => markAsRead(n.id)}>
              <div className="flex items-start gap-3">
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900 truncate">{n.title}</p>
                  <p className="text-sm text-gray-600 mt-1">{n.message}</p>
                  <p className="text-xs text-gray-400 mt-2">{formatDistanceToNow(new Date(n.created_at), { addSuffix: true })}</p>
                </div>
                {!n.read_at && <div className="w-2 h-2 bg-blue-600 rounded-full mt-2" />}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  )
}


